import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';

import LoadAnimation from '../../../decorators/LoadAnimation';

import style from './style.module.css';

const Content = LoadAnimation(
  props => {
    const { children } = props;

    return <div className={style.list}>{children}</div>;
  },
  undefined,
  style.absoluteLoading,
);

/**
 * Stateless component for result grid.
 *
 * @param props {Object}.
 * @param props.id {function} Id of grid container.
 * @param props.loading {function} Indicate grid is in loading state.
 * @param props.isActive {function} Indicate that the grid is currently active.
 * @param props.children {any} Children elements.
 */
const ResultGridComponent = ({ id, isActive, children, loading }) => (
  <div className={classNames(style.host, { [style.active]: isActive })} id={id} role="tabpanel">
    <Content loading={loading}>{children}</Content>
  </div>
);

ResultGridComponent.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
};

export const ResultGrid = memo(ResultGridComponent);
